import React from 'react';

export default function CostCenter() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Cost Center</h1>
      <p className="text-gray-500">Halaman Cost Center</p>
    </div>
  );
}
